import { Staff } from '../lib/staff';

export type WarrantyPermissionId = (typeof Permissions)[number]['id'];
export const Permissions = <const>[
  {
    id: 'wrt_ViewWarranty',
    display: {
      title: 'View warranty',
      description: 'View warranties',
    },
  },
  {
    id: 'wrt_CreateWarranty',
    display: {
      title: 'Create warranties',
      description: 'Ability to create waranties and finalize draft warranties',
    },
  },
  {
    id: 'wrt_CreateDraftWarranty',
    display: {
      title: 'Sell draft warranties',
      description: 'Ability to create draft waranties',
    },
  },
  {
    id: 'wrt_UpdateWarranty',
    display: {
      title: 'Update warranty',
      description: 'Update the warranty details',
    },
  },
  {
    id: 'wrt_AdjustWarranty',
    display: {
      title: 'Adjust warranty',
      description: 'Adjust the warranty details',
    },
  },
  {
    id: 'wrt_CancelWarranty',
    display: {
      title: 'Cancel warranty',
      description: 'Cancel a warranty and its upcoming payments if applicable',
    },
  },
  {
    id: 'wrt_RecordSellerPayout',
    display: {
      title: 'Record seller payout',
      description: 'Manually record a payout made to a seller outside WarrantySphere',
    },
  },
  {
    id: 'wrt_ViewRatingMatrix',
    display: {
      title: 'View rating matrix',
      description: 'View the rating matrix for warranty pricing',
    },
  },
  {
    id: 'wrt_EditRatingMatrix',
    display: {
      title: 'Edit rating matrix',
      description: 'Create, update, and delete rating matrix dimensions, elements, and cell values',
    },
  },
];
Permissions.forEach(p => new Staff.Security.Permission(p));
